import { ListagemConteudoEletronicoComponent } from './../listagem-conteudo-eletronico/listagem-conteudo-eletronico.component';
import { ConteudoService } from './../../../service/caixa/conteudo.service';
import { DialogConfirmComponent } from './../../dialog/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { CaixaService } from './../../../service/caixa/caixa.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@alfresco/adf-core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { FormControl, FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { connect } from 'net';

export class Atributo {
  operador: Operador[];
  descricao: String;
  valor: String;
  tipo: String;
}
export class Operador {
  operador: String;
  value: String;
}
@Component({
  selector: 'app-pesquisa-conteudo-avancada',
  templateUrl: './pesquisa-conteudo-avancada.component.html',
  styleUrls: ['./pesquisa-conteudo-avancada.component.scss']
})
export class PesquisaConteudoAvancadaComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  caixas: any[] = [];
  conteudos: any[] = [];
  displayedColumns = ['rgCaixa', 'rgItem', 'tipoRegistro', 'dataInicial',
  'dataFinal', 'origem', 'descricao', 'numDocInicial', 'numDocFinal', 'acoes'];
  dataSource = new MatTableDataSource<any[]>([]);
  public clientes: ClienteModel[];
  queryField = new FormControl();
  public inputPesquisa = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public loading = false;
  idCaixa;
  clientePesquisado;
  pesquisaForm: FormGroup;
  pesquisaFormArray: FormArray;
  submit = false;
  deData;
  clienteId;
  disabled = ['string'];
  adm = false;
  acervo = true;
  solicitacao = false;

  operadorGeral: Operador[] = [
    {operador: 'igual', value: 'igual'},
    {operador: 'contenha', value: 'contenha'},
    {operador: 'comece com', value: 'comeceCom'},
    {operador: 'termine com', value: 'termineCom'},
  ];

  operadorIgual: Operador[] = [
    {operador: 'igual', value: 'igual'}
  ];

  status = new Array<Atributo>();

  constructor(private authService: AuthenticationService,
    private router: Router,
    private conteudoService: ConteudoService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private caixaService: CaixaService,
    private clienteService: ClienteService,
    private _snackBar: MatSnackBar,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private dialog: MatDialog) {

      let descricao = new Atributo();
      descricao.descricao = 'Descrição';
      descricao.valor = 'descricao';
      descricao.operador = this.operadorGeral;
      descricao.tipo = 'string';

      let tipoRegistro = new Atributo();
      tipoRegistro.descricao = 'Tipo de Registro';
      tipoRegistro.valor = 'tipoRegistro';
      tipoRegistro.operador = this.operadorGeral;
      tipoRegistro.tipo = 'string';

      let rgCaixa = new Atributo();
      rgCaixa.descricao = 'RG Caixa';
      rgCaixa.valor = 'rgCaixa';
      rgCaixa.operador = this.operadorGeral;
      rgCaixa.tipo = 'string';

      let rgItem = new Atributo();
      rgItem.descricao = 'RG Item';
      rgItem.valor = 'rgItem';
      rgItem.operador = this.operadorIgual;
      rgItem.tipo = 'string';

      let origem = new Atributo();
      origem.descricao = 'Origem';
      origem.valor = 'origem';
      origem.operador = this.operadorGeral;
      origem.tipo = 'string';

      let dataInicial = new Atributo();
      dataInicial.descricao = 'Data Inicial';
      dataInicial.valor = 'dataInicial';
      dataInicial.operador = this.operadorGeral;
      dataInicial.tipo = 'date';

      let dataFinal = new Atributo();
      dataFinal.descricao = 'Data Final';
      dataFinal.valor = 'dataFinal';
      dataFinal.operador = this.operadorGeral;
      dataFinal.tipo = 'date';

      let numDocInicial = new Atributo();
      numDocInicial.descricao = 'Número do Documento Inicial';
      numDocInicial.valor = 'numDocInicial';
      origem.operador = this.operadorGeral;
      origem.tipo = 'string';

      let numDocFinal = new Atributo();
      numDocFinal.descricao = 'Número do Documento Final';
      numDocFinal.valor = 'numDocFinal';
      origem.operador = this.operadorGeral;
      origem.tipo = 'string';

      this.status.push(rgCaixa, rgItem, tipoRegistro, dataInicial, dataFinal,
        origem, descricao, numDocInicial, numDocFinal);

      iconRegistry.addSvgIcon('addItens', sanitizer.bypassSecurityTrustResourceUrl('../../../../assets/images/file-earmark-diff.svg'));
      this.route.params.subscribe(params => this.clienteId = params['id']);
      this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
      this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));

    }

  ngOnInit() {
    this.listarClientesUsuario();

    this.pesquisaForm = this.formBuilder.group({
      pesquisaFormArray: this.formBuilder.array([ this.createItem() ])
    });
  }

  onSubmit() {
    this.submit = true;
  }

  exibirConteudoEletronico(element) {
    const dialogRef = this.dialog.open(ListagemConteudoEletronicoComponent, {
      width: '100%',
      data: {conteudoId: element.id, descricaoConteudo: element.descricaoConteudo}
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      console.log(result);
    });
  }
  
  onChange(indice) {
    this.desabilitarOperador(indice);
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      atributo: ['', [Validators.required]],
      operador: ['', Validators.required],
      conteudo: ['', [Validators.required]]
    });
  }

  desabilitarOperador(indice) {
    const group = this.pesquisaForm.get('pesquisaFormArray').value[indice];
    const arrayGroup = ['dataInicial', 'dataFinal'];
    const arrayGroupNumber = ['numeroDoc']
    if (arrayGroup.includes(group.atributo)) {
      this.disabled[indice] = 'date';
    } else if (arrayGroupNumber.includes(group.atributo))  {
      this.disabled[indice] = 'number'
    }
    else {
      this.disabled[indice] = 'string';
    }
  }

  createItemStatus(): FormGroup {
    return this.formBuilder.group({
      atributo: ['', [Validators.required]],
      operador: ['igual', Validators.required],
      conteudo: ['', [Validators.required]]
    });
  }

  addItem() {
    this.disabled.push('string');
    this.pesquisaFormArray = this.pesquisaForm.get('pesquisaFormArray') as FormArray;
    this.pesquisaFormArray.push(this.createItem());
  }

  remover(indice: any) {
    if (indice > 0) {
      this.pesquisaFormArray.removeAt(indice);
      this.disabled.splice(indice, 1);
    }else {
      this.openSnackBarError('Erro ao remover. O primeiro filtro é obrigatório !');
    }
  }

  pesquisarConteudo() {
    this.loading = true;
    const arrayPesquisa = this.pesquisaForm.get('pesquisaFormArray').value;
    this.conteudoService.pesquisaAvancadaConteudo(this.clienteId, arrayPesquisa).subscribe(data => {
      if (data.length === 0) {
        this.loading = false;
        this.openSnackBarError('Nenhum resultado encontrado !');
      }
      this.loading = false;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Erro ao tentar realizar a busca.');
    });
  }

  limpar() {
    this.submit = false;
  }

  fecharCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.', from: 'listar-caixa.component.ts'}
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.fechaCaixaFunction(caixaId);
      }
    });
  }

  fechaCaixaFunction(idCaixa) {
    this.caixaService.fecharCaixa(idCaixa).subscribe(() => {
      this.openSnackBarSuccess('Caixa fechada com sucesso !');
      setTimeout(() => {
        this.getCaixas(this.clientePesquisado);
      }, 2000);
    }, err => {
      this.openSnackBarError('Erro ao tentar fechar a caixa !');
      console.log(err);
    });
  }

  abrirCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja abrir esta caixa ? Obs: Isso permitirá incluir mais itens na caixa.', from: 'listar-caixa.component.ts'}
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.abrirCaixaFunction(caixaId);
      }
    });
  }

  abrirCaixaFunction(idCaixa) {
    this.caixaService.abrirCaixa(idCaixa).subscribe(() => {
      this.openSnackBarSuccess('Caixa aberta com sucesso !');
      setTimeout(() => {
        this.getCaixas(this.clientePesquisado);
      }, 2000);
    }, err => {
      this.openSnackBarError('Erro ao tentar abrir a caixa !');
      console.log(err);
    })
  }

  onSearch() {
    let value = (<HTMLSelectElement>document.getElementById('selectCliente')).value;
    this.clientePesquisado = parseInt(value);
    if(parseInt(value) == 0) {
      this.openSnackBarError('Nenhum Cliente selecionado !');
      return null;
    }
    this.getCaixas(parseInt(value));
  }

  getCaixas(idCliente: number) {
    this.loading = true;
    this.caixaService.getCaixasIdCliente(idCliente).subscribe(data => {
      this.loading = false;
      if ( data.length !== 0 ) {
        this.inputPesquisa = true;
      } else {
        this.inputPesquisa = false;
        this.openSnackBarError(`Nenhuma caixa encontrada neste Cliente !`);
      }
      this.caixas = data;
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }, err => {
      console.error(err);
      this.loading = false;
    });
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
    }, err => {
      console.error(err);
    });
  }

  aplicarFiltros(filter: string) {
    filter = filter.trim();
    filter = filter.toLowerCase();
    this.dataSource.filter = filter;
  }

  deleteCaixa(caixaId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar esta caixa ? Obs: Isso apagará todos os itens da caixa.', from: 'listar-caixa.component.ts'}
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarCaixa(caixaId);
      }
    });
  }

  editCaixa(caixaId: number) {
    this.idCaixa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(caixaId), 'pcdoc').toString());
    this.router.navigate(['/editar-caixa', this.idCaixa]);
  }

  apagarCaixa(caixaId: number) {
    this.loading = true;
    this.caixaService.apagarCaixa(caixaId).subscribe(() => {
      this.loading = false;
      this.getCaixas(this.clientePesquisado);
      this.openSnackBarSuccess('Caixa excluída com sucesso !');
    }, err => {
      this.loading = false;
      this.openSnackBarError('Erro ao tentar excluír esta caixa !');
      console.error(err);
    });
  }

  incluirIntens(id) {
    this.idCaixa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/incluir-conteudo', this.idCaixa]);
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }


}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/pesquisa-conteudo-avancada/pesquisa-conteudo-avancada.component.ts